/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const ProjectsDocument = gql`
    query Projects {
  user {
    domains {
      id
      title
    }
  }
}
    `;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
// @ts-ignore
export function useProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectsQuery, ProjectsQueryVariables>;
export function useProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectsQuery | undefined, ProjectsQueryVariables>;
export function useProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsSuspenseQueryHookResult = ReturnType<typeof useProjectsSuspenseQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const DomainNewDocument = gql`
    mutation DomainNew($title: String!) {
  domainNew(title: $title) {
    id
  }
}
    `;
export type DomainNewMutationFn = Apollo.MutationFunction<DomainNewMutation, DomainNewMutationVariables>;

/**
 * __useDomainNewMutation__
 *
 * To run a mutation, you first call `useDomainNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainNewMutation, { data, loading, error }] = useDomainNewMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useDomainNewMutation(baseOptions?: Apollo.MutationHookOptions<DomainNewMutation, DomainNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainNewMutation, DomainNewMutationVariables>(DomainNewDocument, options);
      }
export type DomainNewMutationHookResult = ReturnType<typeof useDomainNewMutation>;
export type DomainNewMutationResult = Apollo.MutationResult<DomainNewMutation>;
export type DomainNewMutationOptions = Apollo.BaseMutationOptions<DomainNewMutation, DomainNewMutationVariables>;
export const ProgectsDomainByIdDocument = gql`
    query ProgectsDomainById($domainId: Int!) {
  domain(domainId: $domainId) {
    id
    title
    userAccesses {
      id
      accessType
      email
      user {
        id
        email
      }
    }
    urlType
  }
}
    `;

/**
 * __useProgectsDomainByIdQuery__
 *
 * To run a query within a React component, call `useProgectsDomainByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgectsDomainByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgectsDomainByIdQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useProgectsDomainByIdQuery(baseOptions: Apollo.QueryHookOptions<ProgectsDomainByIdQuery, ProgectsDomainByIdQueryVariables> & ({ variables: ProgectsDomainByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgectsDomainByIdQuery, ProgectsDomainByIdQueryVariables>(ProgectsDomainByIdDocument, options);
      }
export function useProgectsDomainByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgectsDomainByIdQuery, ProgectsDomainByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgectsDomainByIdQuery, ProgectsDomainByIdQueryVariables>(ProgectsDomainByIdDocument, options);
        }
// @ts-ignore
export function useProgectsDomainByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProgectsDomainByIdQuery, ProgectsDomainByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ProgectsDomainByIdQuery, ProgectsDomainByIdQueryVariables>;
export function useProgectsDomainByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgectsDomainByIdQuery, ProgectsDomainByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ProgectsDomainByIdQuery | undefined, ProgectsDomainByIdQueryVariables>;
export function useProgectsDomainByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgectsDomainByIdQuery, ProgectsDomainByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProgectsDomainByIdQuery, ProgectsDomainByIdQueryVariables>(ProgectsDomainByIdDocument, options);
        }
export type ProgectsDomainByIdQueryHookResult = ReturnType<typeof useProgectsDomainByIdQuery>;
export type ProgectsDomainByIdLazyQueryHookResult = ReturnType<typeof useProgectsDomainByIdLazyQuery>;
export type ProgectsDomainByIdSuspenseQueryHookResult = ReturnType<typeof useProgectsDomainByIdSuspenseQuery>;
export type ProgectsDomainByIdQueryResult = Apollo.QueryResult<ProgectsDomainByIdQuery, ProgectsDomainByIdQueryVariables>;
export const DomainEditDocument = gql`
    mutation DomainEdit($domainId: Int!, $title: String!, $urlType: Int!) {
  domainEdit(domainId: $domainId, title: $title, urlType: $urlType) {
    id
  }
}
    `;
export type DomainEditMutationFn = Apollo.MutationFunction<DomainEditMutation, DomainEditMutationVariables>;

/**
 * __useDomainEditMutation__
 *
 * To run a mutation, you first call `useDomainEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainEditMutation, { data, loading, error }] = useDomainEditMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      title: // value for 'title'
 *      urlType: // value for 'urlType'
 *   },
 * });
 */
export function useDomainEditMutation(baseOptions?: Apollo.MutationHookOptions<DomainEditMutation, DomainEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainEditMutation, DomainEditMutationVariables>(DomainEditDocument, options);
      }
export type DomainEditMutationHookResult = ReturnType<typeof useDomainEditMutation>;
export type DomainEditMutationResult = Apollo.MutationResult<DomainEditMutation>;
export type DomainEditMutationOptions = Apollo.BaseMutationOptions<DomainEditMutation, DomainEditMutationVariables>;
export const DomainDeleteDocument = gql`
    mutation DomainDelete($domainId: Int!) {
  domainDelete(domainId: $domainId)
}
    `;
export type DomainDeleteMutationFn = Apollo.MutationFunction<DomainDeleteMutation, DomainDeleteMutationVariables>;

/**
 * __useDomainDeleteMutation__
 *
 * To run a mutation, you first call `useDomainDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainDeleteMutation, { data, loading, error }] = useDomainDeleteMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DomainDeleteMutation, DomainDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainDeleteMutation, DomainDeleteMutationVariables>(DomainDeleteDocument, options);
      }
export type DomainDeleteMutationHookResult = ReturnType<typeof useDomainDeleteMutation>;
export type DomainDeleteMutationResult = Apollo.MutationResult<DomainDeleteMutation>;
export type DomainDeleteMutationOptions = Apollo.BaseMutationOptions<DomainDeleteMutation, DomainDeleteMutationVariables>;
export const PagesByDomainDocument = gql`
    query PagesByDomain($domainId: Int!, $page: Int, $limit: Int, $search: String) {
  pagesByDomain(domainId: $domainId, page: $page, limit: $limit, search: $search) {
    paginator {
      totalPages
      currentPageNumber
      itemNumberPerPage
      totalItemCount
    }
    pagesWithoutFolder {
      publishedAt
      published
      publicUrl
      id
      title
      type
      image
      user {
        email
      }
      userAccesses {
        accessType
        user {
          id
          email
        }
      }
      subPages {
        id
      }
    }
    folders {
      userAccesses {
        accessType
        user {
          id
          email
        }
      }
      id
      title
      url
    }
    domain {
      userAccesses {
        accessType
        user {
          id
          email
        }
      }
      id
      title
    }
  }
}
    `;

/**
 * __usePagesByDomainQuery__
 *
 * To run a query within a React component, call `usePagesByDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesByDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesByDomainQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePagesByDomainQuery(baseOptions: Apollo.QueryHookOptions<PagesByDomainQuery, PagesByDomainQueryVariables> & ({ variables: PagesByDomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesByDomainQuery, PagesByDomainQueryVariables>(PagesByDomainDocument, options);
      }
export function usePagesByDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesByDomainQuery, PagesByDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesByDomainQuery, PagesByDomainQueryVariables>(PagesByDomainDocument, options);
        }
// @ts-ignore
export function usePagesByDomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PagesByDomainQuery, PagesByDomainQueryVariables>): Apollo.UseSuspenseQueryResult<PagesByDomainQuery, PagesByDomainQueryVariables>;
export function usePagesByDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesByDomainQuery, PagesByDomainQueryVariables>): Apollo.UseSuspenseQueryResult<PagesByDomainQuery | undefined, PagesByDomainQueryVariables>;
export function usePagesByDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesByDomainQuery, PagesByDomainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagesByDomainQuery, PagesByDomainQueryVariables>(PagesByDomainDocument, options);
        }
export type PagesByDomainQueryHookResult = ReturnType<typeof usePagesByDomainQuery>;
export type PagesByDomainLazyQueryHookResult = ReturnType<typeof usePagesByDomainLazyQuery>;
export type PagesByDomainSuspenseQueryHookResult = ReturnType<typeof usePagesByDomainSuspenseQuery>;
export type PagesByDomainQueryResult = Apollo.QueryResult<PagesByDomainQuery, PagesByDomainQueryVariables>;
export const PagesByFolderDocument = gql`
    query PagesByFolder($folderId: Int!, $page: Int, $limit: Int, $search: String) {
  pagesByFolder(folderId: $folderId, page: $page, limit: $limit, search: $search) {
    folders {
      pages {
        publishedAt
        published
        publicUrl
      }
      id
      title
      url
      userAccesses {
        accessType
        user {
          id
          email
        }
      }
      childrenFolders {
        id
        title
        url
        pages {
          id
          type
          title
          image
        }
      }
      parentFolder {
        id
        title
        url
        childrenFolders {
          id
          title
        }
        domain {
          id
          title
        }
      }
    }
    paginator {
      totalPages
      currentPageNumber
      itemNumberPerPage
      totalItemCount
    }
    pages {
      id
      type
      title
      image
      publishedAt
      published
      publicUrl
    }
    folder {
      accessFolderDomainByPriority
      userAccesses {
        accessType
        user {
          id
          email
        }
      }
      id
      title
      domain {
        accessDomain
        userAccesses {
          accessType
          user {
            id
            email
          }
        }
        id
        title
      }
      parentFolder {
        id
        title
      }
    }
  }
}
    `;

/**
 * __usePagesByFolderQuery__
 *
 * To run a query within a React component, call `usePagesByFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesByFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesByFolderQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePagesByFolderQuery(baseOptions: Apollo.QueryHookOptions<PagesByFolderQuery, PagesByFolderQueryVariables> & ({ variables: PagesByFolderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesByFolderQuery, PagesByFolderQueryVariables>(PagesByFolderDocument, options);
      }
export function usePagesByFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesByFolderQuery, PagesByFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesByFolderQuery, PagesByFolderQueryVariables>(PagesByFolderDocument, options);
        }
// @ts-ignore
export function usePagesByFolderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PagesByFolderQuery, PagesByFolderQueryVariables>): Apollo.UseSuspenseQueryResult<PagesByFolderQuery, PagesByFolderQueryVariables>;
export function usePagesByFolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesByFolderQuery, PagesByFolderQueryVariables>): Apollo.UseSuspenseQueryResult<PagesByFolderQuery | undefined, PagesByFolderQueryVariables>;
export function usePagesByFolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesByFolderQuery, PagesByFolderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagesByFolderQuery, PagesByFolderQueryVariables>(PagesByFolderDocument, options);
        }
export type PagesByFolderQueryHookResult = ReturnType<typeof usePagesByFolderQuery>;
export type PagesByFolderLazyQueryHookResult = ReturnType<typeof usePagesByFolderLazyQuery>;
export type PagesByFolderSuspenseQueryHookResult = ReturnType<typeof usePagesByFolderSuspenseQuery>;
export type PagesByFolderQueryResult = Apollo.QueryResult<PagesByFolderQuery, PagesByFolderQueryVariables>;
export const DeletePage2Document = gql`
    mutation DeletePage2($id: Int) {
  deletePage(id: $id) {
    id
  }
}
    `;
export type DeletePage2MutationFn = Apollo.MutationFunction<DeletePage2Mutation, DeletePage2MutationVariables>;

/**
 * __useDeletePage2Mutation__
 *
 * To run a mutation, you first call `useDeletePage2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePage2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePage2Mutation, { data, loading, error }] = useDeletePage2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePage2Mutation(baseOptions?: Apollo.MutationHookOptions<DeletePage2Mutation, DeletePage2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePage2Mutation, DeletePage2MutationVariables>(DeletePage2Document, options);
      }
export type DeletePage2MutationHookResult = ReturnType<typeof useDeletePage2Mutation>;
export type DeletePage2MutationResult = Apollo.MutationResult<DeletePage2Mutation>;
export type DeletePage2MutationOptions = Apollo.BaseMutationOptions<DeletePage2Mutation, DeletePage2MutationVariables>;
export const LandingPageCategoryDocument = gql`
    query LandingPageCategory($order: String) {
  landingPageCategory(order: $order) {
    id
    title
    pages {
      id
      image
      link
      fieldMode
      type
    }
  }
}
    `;

/**
 * __useLandingPageCategoryQuery__
 *
 * To run a query within a React component, call `useLandingPageCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPageCategoryQuery({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLandingPageCategoryQuery(baseOptions?: Apollo.QueryHookOptions<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>(LandingPageCategoryDocument, options);
      }
export function useLandingPageCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>(LandingPageCategoryDocument, options);
        }
// @ts-ignore
export function useLandingPageCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>;
export function useLandingPageCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<LandingPageCategoryQuery | undefined, LandingPageCategoryQueryVariables>;
export function useLandingPageCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>(LandingPageCategoryDocument, options);
        }
export type LandingPageCategoryQueryHookResult = ReturnType<typeof useLandingPageCategoryQuery>;
export type LandingPageCategoryLazyQueryHookResult = ReturnType<typeof useLandingPageCategoryLazyQuery>;
export type LandingPageCategorySuspenseQueryHookResult = ReturnType<typeof useLandingPageCategorySuspenseQuery>;
export type LandingPageCategoryQueryResult = Apollo.QueryResult<LandingPageCategoryQuery, LandingPageCategoryQueryVariables>;
export const SetDomainUrlDocument = gql`
    mutation SetDomainUrl($domainId: Int!, $urlType: Int!, $domainUrl: String!) {
  setDomainUrl(domainId: $domainId, urlType: $urlType, domainUrl: $domainUrl) {
    id
  }
}
    `;
export type SetDomainUrlMutationFn = Apollo.MutationFunction<SetDomainUrlMutation, SetDomainUrlMutationVariables>;

/**
 * __useSetDomainUrlMutation__
 *
 * To run a mutation, you first call `useSetDomainUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDomainUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDomainUrlMutation, { data, loading, error }] = useSetDomainUrlMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      urlType: // value for 'urlType'
 *      domainUrl: // value for 'domainUrl'
 *   },
 * });
 */
export function useSetDomainUrlMutation(baseOptions?: Apollo.MutationHookOptions<SetDomainUrlMutation, SetDomainUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDomainUrlMutation, SetDomainUrlMutationVariables>(SetDomainUrlDocument, options);
      }
export type SetDomainUrlMutationHookResult = ReturnType<typeof useSetDomainUrlMutation>;
export type SetDomainUrlMutationResult = Apollo.MutationResult<SetDomainUrlMutation>;
export type SetDomainUrlMutationOptions = Apollo.BaseMutationOptions<SetDomainUrlMutation, SetDomainUrlMutationVariables>;
export const DomainStatusByApiDocument = gql`
    query DomainStatusByApi($domainId: Int!) {
  domainStatusByApi(domainId: $domainId) {
    id
    domainStatus
    domainUrl
    urlType
  }
}
    `;

/**
 * __useDomainStatusByApiQuery__
 *
 * To run a query within a React component, call `useDomainStatusByApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainStatusByApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainStatusByApiQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainStatusByApiQuery(baseOptions: Apollo.QueryHookOptions<DomainStatusByApiQuery, DomainStatusByApiQueryVariables> & ({ variables: DomainStatusByApiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainStatusByApiQuery, DomainStatusByApiQueryVariables>(DomainStatusByApiDocument, options);
      }
export function useDomainStatusByApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainStatusByApiQuery, DomainStatusByApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainStatusByApiQuery, DomainStatusByApiQueryVariables>(DomainStatusByApiDocument, options);
        }
// @ts-ignore
export function useDomainStatusByApiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DomainStatusByApiQuery, DomainStatusByApiQueryVariables>): Apollo.UseSuspenseQueryResult<DomainStatusByApiQuery, DomainStatusByApiQueryVariables>;
export function useDomainStatusByApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainStatusByApiQuery, DomainStatusByApiQueryVariables>): Apollo.UseSuspenseQueryResult<DomainStatusByApiQuery | undefined, DomainStatusByApiQueryVariables>;
export function useDomainStatusByApiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainStatusByApiQuery, DomainStatusByApiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainStatusByApiQuery, DomainStatusByApiQueryVariables>(DomainStatusByApiDocument, options);
        }
export type DomainStatusByApiQueryHookResult = ReturnType<typeof useDomainStatusByApiQuery>;
export type DomainStatusByApiLazyQueryHookResult = ReturnType<typeof useDomainStatusByApiLazyQuery>;
export type DomainStatusByApiSuspenseQueryHookResult = ReturnType<typeof useDomainStatusByApiSuspenseQuery>;
export type DomainStatusByApiQueryResult = Apollo.QueryResult<DomainStatusByApiQuery, DomainStatusByApiQueryVariables>;
export const DomainDeleteByApiDocument = gql`
    mutation DomainDeleteByApi($domainId: Int!) {
  domainDeleteByApi(domainId: $domainId)
}
    `;
export type DomainDeleteByApiMutationFn = Apollo.MutationFunction<DomainDeleteByApiMutation, DomainDeleteByApiMutationVariables>;

/**
 * __useDomainDeleteByApiMutation__
 *
 * To run a mutation, you first call `useDomainDeleteByApiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainDeleteByApiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainDeleteByApiMutation, { data, loading, error }] = useDomainDeleteByApiMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainDeleteByApiMutation(baseOptions?: Apollo.MutationHookOptions<DomainDeleteByApiMutation, DomainDeleteByApiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainDeleteByApiMutation, DomainDeleteByApiMutationVariables>(DomainDeleteByApiDocument, options);
      }
export type DomainDeleteByApiMutationHookResult = ReturnType<typeof useDomainDeleteByApiMutation>;
export type DomainDeleteByApiMutationResult = Apollo.MutationResult<DomainDeleteByApiMutation>;
export type DomainDeleteByApiMutationOptions = Apollo.BaseMutationOptions<DomainDeleteByApiMutation, DomainDeleteByApiMutationVariables>;
export const DomainRetryDocument = gql`
    mutation DomainRetry($domainId: Int!) {
  domainRetry(domainId: $domainId) {
    id
  }
}
    `;
export type DomainRetryMutationFn = Apollo.MutationFunction<DomainRetryMutation, DomainRetryMutationVariables>;

/**
 * __useDomainRetryMutation__
 *
 * To run a mutation, you first call `useDomainRetryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainRetryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainRetryMutation, { data, loading, error }] = useDomainRetryMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainRetryMutation(baseOptions?: Apollo.MutationHookOptions<DomainRetryMutation, DomainRetryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainRetryMutation, DomainRetryMutationVariables>(DomainRetryDocument, options);
      }
export type DomainRetryMutationHookResult = ReturnType<typeof useDomainRetryMutation>;
export type DomainRetryMutationResult = Apollo.MutationResult<DomainRetryMutation>;
export type DomainRetryMutationOptions = Apollo.BaseMutationOptions<DomainRetryMutation, DomainRetryMutationVariables>;
export type ProjectsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProjectsQuery = { __typename?: 'Query', user?: { __typename?: 'GraphUser', domains: Array<{ __typename?: 'GraphDomain', id?: number | null, title?: string | null }> } | null };

export type DomainNewMutationVariables = Types.Exact<{
  title: Types.Scalars['String']['input'];
}>;


export type DomainNewMutation = { __typename?: 'Mutation', domainNew: { __typename?: 'GraphDomain', id?: number | null } };

export type ProgectsDomainByIdQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type ProgectsDomainByIdQuery = { __typename?: 'Query', domain: { __typename?: 'GraphDomain', id?: number | null, title?: string | null, urlType?: number | null, userAccesses: Array<{ __typename?: 'UserAccess', id?: number | null, accessType?: number | null, email?: string | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> } };

export type DomainEditMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  title: Types.Scalars['String']['input'];
  urlType: Types.Scalars['Int']['input'];
}>;


export type DomainEditMutation = { __typename?: 'Mutation', domainEdit: { __typename?: 'GraphDomain', id?: number | null } };

export type DomainDeleteMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainDeleteMutation = { __typename?: 'Mutation', domainDelete: number };

export type PagesByDomainQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PagesByDomainQuery = { __typename?: 'Query', pagesByDomain: { __typename?: 'GraphDomainPagePaginator', paginator: { __typename?: 'GraphPaginator', totalPages: number, currentPageNumber: number, itemNumberPerPage: number, totalItemCount: number }, pagesWithoutFolder: Array<{ __typename?: 'GraphPage', publishedAt?: any | null, published: boolean, publicUrl?: string | null, id?: number | null, title?: string | null, type?: number | null, image?: string | null, user: { __typename?: 'User', email?: string | null }, userAccesses: Array<{ __typename?: 'UserAccess', accessType?: number | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }>, subPages: Array<{ __typename?: 'GraphPage', id?: number | null }> }>, folders: Array<{ __typename?: 'GraphFolder', id: number, title: string, url?: string | null, userAccesses: Array<{ __typename?: 'UserAccess', accessType?: number | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> }>, domain: { __typename?: 'GraphDomain', id?: number | null, title?: string | null, userAccesses: Array<{ __typename?: 'UserAccess', accessType?: number | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> } } };

export type PagesByFolderQueryVariables = Types.Exact<{
  folderId: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type PagesByFolderQuery = { __typename?: 'Query', pagesByFolder: { __typename?: 'GraphFolderPagePaginator', folders: Array<{ __typename?: 'GraphFolder', id: number, title: string, url?: string | null, pages: Array<{ __typename?: 'GraphPage', publishedAt?: any | null, published: boolean, publicUrl?: string | null }>, userAccesses: Array<{ __typename?: 'UserAccess', accessType?: number | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }>, childrenFolders: Array<{ __typename?: 'GraphFolder', id: number, title: string, url?: string | null, pages: Array<{ __typename?: 'GraphPage', id?: number | null, type?: number | null, title?: string | null, image?: string | null }> }>, parentFolder?: { __typename?: 'GraphFolder', id: number, title: string, url?: string | null, childrenFolders: Array<{ __typename?: 'GraphFolder', id: number, title: string }>, domain?: { __typename?: 'GraphDomain', id?: number | null, title?: string | null } | null } | null }>, paginator: { __typename?: 'GraphPaginator', totalPages: number, currentPageNumber: number, itemNumberPerPage: number, totalItemCount: number }, pages: Array<{ __typename?: 'GraphPage', id?: number | null, type?: number | null, title?: string | null, image?: string | null, publishedAt?: any | null, published: boolean, publicUrl?: string | null }>, folder?: { __typename?: 'GraphFolder', accessFolderDomainByPriority: number, id: number, title: string, userAccesses: Array<{ __typename?: 'UserAccess', accessType?: number | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }>, domain?: { __typename?: 'GraphDomain', accessDomain: number, id?: number | null, title?: string | null, userAccesses: Array<{ __typename?: 'UserAccess', accessType?: number | null, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> } | null, parentFolder?: { __typename?: 'GraphFolder', id: number, title: string } | null } | null } };

export type DeletePage2MutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type DeletePage2Mutation = { __typename?: 'Mutation', deletePage: { __typename?: 'Page', id?: number | null } };

export type LandingPageCategoryQueryVariables = Types.Exact<{
  order?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LandingPageCategoryQuery = { __typename?: 'Query', landingPageCategory?: Array<{ __typename?: 'GraphPageCategoryLanding', id?: number | null, title?: string | null, pages: Array<{ __typename?: 'GraphPageLanding', id?: number | null, image?: string | null, link?: string | null, fieldMode?: boolean | null, type?: number | null }> }> | null };

export type SetDomainUrlMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  urlType: Types.Scalars['Int']['input'];
  domainUrl: Types.Scalars['String']['input'];
}>;


export type SetDomainUrlMutation = { __typename?: 'Mutation', setDomainUrl: { __typename?: 'GraphDomain', id?: number | null } };

export type DomainStatusByApiQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainStatusByApiQuery = { __typename?: 'Query', domainStatusByApi: { __typename?: 'GraphDomain', id?: number | null, domainStatus?: string | null, domainUrl?: string | null, urlType?: number | null } };

export type DomainDeleteByApiMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainDeleteByApiMutation = { __typename?: 'Mutation', domainDeleteByApi: boolean };

export type DomainRetryMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainRetryMutation = { __typename?: 'Mutation', domainRetry: { __typename?: 'GraphDomain', id?: number | null } };
